exports = module.exports = require("../../../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".DS__FieldTooltip__root {\n  display: block;\n  margin-top: 4px;\n  margin-left: 16px;\n  color: #7a869a;\n}\n\n.DS__FieldTooltip__invalid {\n  color: #f14d56;\n}\n\n.DS__FieldTooltip__success {\n  color: #81a11a;\n}\n\n.DS__FieldTooltip__absolute {\n  position: absolute;\n  top: calc(100% + 15px);\n  left: 16px;\n  margin: 0;\n}\n", ""]);

// exports
exports.locals = {
	"root": "DS__FieldTooltip__root",
	"invalid": "DS__FieldTooltip__invalid",
	"success": "DS__FieldTooltip__success",
	"absolute": "DS__FieldTooltip__absolute"
};